/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import { IModuleProps, Module, Node, getTelemetryObject } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
import { getAsset } from '@msdyn365-commerce/core';

import { IReviewModalViewProps } from '@msdyn365-commerce-modules/ratings-reviews/src/modules/write-review/../../common/review-modal';
import { IWriteReviewViewProps } from '@msdyn365-commerce-modules/ratings-reviews/src/modules/write-review/./write-review';

import { SignInButton } from '../../../components/signinbutton.component';
import { IWriteReviewProps } from '../definition-extensions/write-review.ext.props.autogenerated';

const WriteReviewView: React.FC<IWriteReviewViewProps & IWriteReviewProps<{}>> = props => {
    const { heading, signInMessage, modalToggle, reviewModal, moduleProps } = props;
    const isAuthenticated = props.context.request.user.isAuthenticated;
    const telemetryContent = getTelemetryObject(props.context.request.telemetryPageName!, props.friendlyName, props.telemetry);
    const defaultBtnBackground = getAsset('images/esl_default.png', props.context.request);
    return (
        <Module {...moduleProps}>
            {heading}
            {!isAuthenticated ? (
                <>
                    {signInMessage}
                    {
                        <SignInButton
                            text={props.resources.signInLabel}
                            ariaLabel='To rate and review, please sign in'
                            href={props.context.request.user.signInUrl!}
                            telemetryContent={telemetryContent}
                            imageURL={props.config?.sigInBackgroundImage.src || defaultBtnBackground}
                        />
                    }
                </>
            ) : (
                <>
                    {modalToggle}
                    {createReviewModal(reviewModal, moduleProps)}
                </>
            )}
        </Module>
    );
};

const createReviewModal = (props: IReviewModalViewProps, moduleProps: IModuleProps): JSX.Element => {
    return (
        <Module {...props.modal} {...moduleProps}>
            {props.modalHeader}
            <Node {...props.modalBody}>
                <Node {...props.form}>
                    <Node {...props.inputRow}>
                        {props.rating}
                        {props.ratingLabel}
                    </Node>
                    <Node {...props.inputRow}>
                        {props.titleLabel}
                        {props.titleInput}
                    </Node>
                    <Node {...props.inputRow}>
                        {props.textLabel}
                        {props.textInput}
                    </Node>
                    {props.privacyPolicyUrl}
                    {props.error}
                </Node>
            </Node>
            <Node {...props.modalFooter}>
                {props.submitButton}
                {props.cancelButton}
            </Node>
        </Module>
    );
};

export default WriteReviewView;
